/*==========================================================
HOMEPAGE RESPONSIVE SCRIPTS
==========================================================*/

$(function() {
    if ($('#uber').hasClass('homepage')) {
        //News and Events Feed
        if ($().matchHeight) {
            $('.matchHeight').matchHeight();
        }
    }

    function emergencyBarHeight () {
        if ( $('.emergencyBarWrapper').length ) {
            var emergencyBarWrapperHeight = 0;
            $('.emergencyBarWrapper').each(function() {
                emergencyBarWrapperHeight += $(this).outerHeight();
            });

            $('#uberMain').css('padding-top', emergencyBarWrapperHeight + 'px');
        }
    }

    emergencyBarHeight();

    $(".emergencyBarWrapper .closeBtn").on("click", function () {
        setTimeout(emergencyBarHeight, 500);
    });

    $(window).scroll(function(event) {
        // Detect scroll position
        var lastScrollTop = 0;  // determines last scrolled position
        var st = $(this).scrollTop();

        if (st == lastScrollTop ) {
            emergencyBarHeight();

        // If user has scrolled down
        } else  {
            $('#uberMain').css('padding-top', '0');
        }
    });
});
